import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  CLIENTS_FEATURE_KEY,
  ClientsState,
  clientsAdapter
} from './clients.reducer';

// Lookup the 'Clients' feature state managed by NgRx
export const getClientsState = createFeatureSelector<ClientsState>(CLIENTS_FEATURE_KEY);

const { selectAll, selectEntities, selectIds, selectTotal } = clientsAdapter.getSelectors();

export const getClientsLoaded = createSelector(
  getClientsState,
  (state: ClientsState) => state.clientsLoaded
);

export const getClientsLoadError = createSelector(
  getClientsState,
  (state: ClientsState) => state.clientsLoadError
);

export const getQueryLoadError = createSelector(
  getClientsState,
  (state: ClientsState) => state.queryClientError
);

export const getAllClients = createSelector(getClientsState, (state: ClientsState) =>
  selectAll(state)
);

export const getClientsEntities = createSelector(
  getClientsState,
  (state: ClientsState) => selectEntities(state)
);

export const getSelectedId = createSelector(
  getClientsState,
  (state: ClientsState) => state.selectedClientId
);

export const getSelected = createSelector(
  getClientsEntities,
  getSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId]
);

export const getActiveClients = createSelector(getAllClients,
  (clients) =>
    clients.filter(client => client.active)
);


export const getClientById = createSelector(getAllClients,
  (clients, props) =>
    clients.find(client => client.id === props.id)
);


export const getAddClientLoaded = createSelector(
  getClientsState,
  (state: ClientsState) => state.addClientLoaded
);


export const getAddClientError = createSelector(
  getClientsState,
  (state: ClientsState) => state.addError
);





